import Repository from "@/services/Repository";

const resource = "/holidays";

export default {
  fetch(schoolYearId) {
    let params = {
      schoolYear: schoolYearId
    };

    return Repository.get(`${resource}/`, { params });
  },
  post(newContent) {
    return Repository.post(`${resource}/`, newContent);
  },
  put(content) {
    return Repository.put(`${resource}/${content.id}`, content);
  },
  delete(contentId) {
    return Repository.delete(`${resource}/${contentId}`);
  }
};
